import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Figure,
  Form,
  Row,
} from "react-bootstrap";
import { Edit, Eye } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { MdDeleteForever } from "react-icons/md";
import {
  deleteMatrimonialApi,
  getMaritalApi,
} from "../../../hooks/ApisContainer/Matrimonial";
import useToastContext from "../../../hooks/useToastContext";
import LottiLoader from "../../../components/shared/Loader/LottiLoader";
import moment from "moment";
import { BASE_URL } from "../../../services/path";
import OPagination from "../../../components/shared/pagination/OPagination";
import NoDataFound from "../../../components/shared/Loader/NoDataAnimation";
import Swal from "sweetalert2";
import { textTruncateMore } from "../../../helper/helper";
import AuthContext from "../../../hooks/context/AuthContext";
import { addInterestMatrimonialDataApi } from "../../../hooks/ApisContainer/InterestMatrimonial";

const Metrimonial = () => {
  const navigate = useNavigate();
  const notification = useToastContext();
  const { user } = useContext(AuthContext);

  const [keyword, setKeyword] = useState("");
  const [loader, setLoader] = useState(false);
  const [marital, setMarital] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalDocs, setTotalDocs] = useState(0);

  const fetchedGetMaritals = () => {
    const requestPayload = { page: currentPage, pageSize: 12 };
    if (keyword) requestPayload.keyword = keyword.trim();
    getMaritalApi(requestPayload, notification, (loading, error, response) => {
      setLoader(loading);
      if (!error) {
        setMarital(response?.docs);
        setTotalDocs(response?.totalDocs);
      }
    });
  };

  const handlePageChange = async (event) => {
    setCurrentPage(event?.selected + 1);
  };

  const handleDeleteMatrimonial = (data = {}) => {
    Swal.fire({
      text: "Are you sure you want to delete?",
      icon: "error",
      showCancelButton: true,
      confirmButtonColor: "#ff6004",
      confirmButtonText: "Delete",
      cancelButtonColor: "#d33",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const requestPayload = { ...data };
          deleteMatrimonialApi(
            requestPayload,
            notification,
            (loading, error, response) => {
              if (!error) {
                fetchedGetMaritals();
              }
            }
          );
        } catch (error) {
          console.error("error:", error);
        }
      }
    });
  };

  const handleAddInterestMatrimonial = (data = {}) => {
    Swal.fire({
      text: "Are you sure you want to send request?",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#ff6004",
      confirmButtonText: "Send",
      cancelButtonColor: "#d33",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const requestPayload = { ...data };
          addInterestMatrimonialDataApi(
            requestPayload,
            notification,
            (loading, error, response) => {
              if (!error) {
                fetchedGetMaritals();
              }
            }
          );
        } catch (error) {
          console.error("error:", error);
        }
      }
    });
  };

  useEffect(() => {
    if (keyword === "") fetchedGetMaritals();
  }, [currentPage, keyword]);

  return (
    <div className="right-panel p-3">
      <div class="common-heading text-start mb-3">
        <h4 className="mb-3 fw-bold fs-5 ">Metrimonial Manager </h4>
      </div>

      <div className="bg-white border text-start p-3 mb-4">
        <Row className="align-items-center gx-2 ">
          <Col md={4} sm={12} className="">
            <Form.Control
              type="text"
              placeholder="Search..."
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
            />
          </Col>

          <Col md={3} xs={6} className="mt-md-0 mt-3">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <Button
                  type="button"
                  className="bg-orange border-0 me-2 normal-size"
                  onClick={() => fetchedGetMaritals()}
                >
                  Filter
                </Button>
                <Button
                  type="button"
                  className="bg-orange border-0 normal-size me-2"
                  onClick={() => setKeyword("")}
                >
                  Reset
                </Button>
              </div>
            </div>
          </Col>
          <Col
            md={5}
            xs={6}
            className="text-end mt-md-0 mt-3"
            onClick={() => navigate("/add-biodata")}
          >
            <Button
              type="button"
              className="bg-black btn text-white border-0 normal-size"
            >
              Add Biodata
            </Button>
          </Col>
        </Row>
      </div>

      <section className="sponser-sec  pt-0 our-team-member pb-0 ">
        <div className="achiever-box gx-2 member-manager-cards d-flex flex-wrap">
          {loader ? (
            <Container className="d-flex justify-content-center align-items-center default-back">
              <span>
                <LottiLoader height={120} width={120} loader={true} />
              </span>
            </Container>
          ) : (
            !loader &&
            marital?.length > 0 &&
            marital.map((item, index) => (
              <Col lg={3} md={4} xs={6} className="mb-3 box-member" key={index}>
                <Card className="sponser-cards  position-relative">
                  <Figure className="position-relative">
                    <Card.Img
                      variant="top"
                      src={`${BASE_URL}/uploads/${item?.image}`}
                      alt="Profile"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src =
                          "https://static.vecteezy.com/system/resources/previews/022/014/063/original/missing-picture-page-for-website-design-or-mobile-app-design-no-image-available-icon-vector.jpg";
                      }}
                    />
                    <div className=" w-100 p-2  position-absolute bottom-0 end-0 matri-edit-delete d-flex align-items-center">
                      {user._id === item.userId && (
                        <Link
                          to={`/edit-biodata/${item._id}`}
                          className="cursor-pointer bg-orange me-2 justiy-content-center"
                        >
                          <Edit className="text-white" />
                        </Link>
                      )}

                      <Link
                        to={`/view-biodata/${item._id}`}
                        className="cursor-pointer bg-orange me-2 justiy-content-center"
                      >
                        <Eye className="text-white" />
                      </Link>
                      {user._id === item.userId && (
                        <Button
                          className="bg-orange p-0"
                          onClick={() =>
                            handleDeleteMatrimonial({ id: item._id })
                          }
                        >
                          <MdDeleteForever />
                        </Button>
                      )}
                    </div>
                  </Figure>
                  <Card.Body className="text-start">
                    {/* <Card.Title className="fw-bold mb-1">
                    {item.name}
                  </Card.Title> */}
                    <Card.Text
                      style={{ color: "gray", fontSize: "14px" }}
                      className="mb-1"
                    >
                      <strong className="text-black">Name:</strong>{" "}
                      {item?.firstName + " " + item?.lastName}
                    </Card.Text>
                    <Card.Text
                      style={{ color: "gray", fontSize: "14px" }}
                      className="mb-1"
                    >
                      <strong className="tex-black">DOB:</strong>{" "}
                      {moment(item?.birthDetails?.dob).format("DD MMM YYYY")}
                    </Card.Text>
                    <Card.Text
                      style={{ color: "gray", fontSize: "14px" }}
                      className="mb-1"
                    >
                      <strong className="text-black">Gender:</strong>{" "}
                      {item?.gender || "Male"}
                    </Card.Text>
                    <Card.Text
                      style={{ color: "gray", fontSize: "14px" }}
                      className="mb-1"
                    >
                      <strong className="text-black">Designation:</strong>{" "}
                      <span
                        className="cursor-pointer"
                        title={item?.officeInformation?.designation}
                      >
                        {item?.officeInformation?.designation
                          ? textTruncateMore(
                              item?.officeInformation?.designation,
                              14
                            )
                          : "Not working"}
                      </span>
                    </Card.Text>
                    <Card.Text
                      style={{ color: "gray", fontSize: "14px" }}
                      className="mb-1"
                    >
                      <strong className="text-black">Package:</strong>{" "}
                      {item?.officeInformation?.annualIncome || "N/A"}
                    </Card.Text>
                    {user._id !== item.userId ? (
                      <Button
                        className="bg-orange border-0 me-2"
                        style={{
                          fontSize: "14px",
                          width: "100%",
                          height: "31px",
                        }}
                        disabled={
                          item?.interestMatrimonialDetail?._id ? true : false
                        }
                        onClick={() =>
                          handleAddInterestMatrimonial({
                            matrimonialId: item._id,
                          })
                        }
                      >
                        {item?.interestMatrimonialDetail?._id
                          ? "Requested"
                          : "Interest"}
                      </Button>
                    ) : (
                      <div style={{ height: "33px", width: "100%" }} />
                    )}
                  </Card.Body>
                </Card>
              </Col>
            ))
          )}
        </div>
        {!loader && marital?.length == 0 && (
          <NoDataFound
            height={200}
            width={200}
            firstMessage="No MatriMonial Found."
          />
        )}
        {!loader && marital && marital?.length > 0 && (
          <div className="d-flex justify-content-center">
            <OPagination
              pageCount={Math.ceil(totalDocs / 10)}
              handlePageClick={(e) => handlePageChange(e)}
              page={currentPage}
            />
          </div>
        )}
      </section>
    </div>
  );
};

export default Metrimonial;
